import React from 'react';

import { getCookie } from '../../helpers/cookie';

export default class FilmComments extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      //TODO: положить сюда айдишник фильма из дата-атрибута
      filmId: document.querySelector('[data-film]').dataset.film,
      commentsList: [],
      lastCommentId: null,
      btnShowMore: false,
    };
  }

  fetchComments = (filmId, offset) =>
    new Promise((resolve, reject) => {
      const requestHeaders = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      };

      const mainRequestUrl = `/local/php_interface/api/v1/user/review/film/find_all_comments_of_film.php?film-id=${filmId}`;
      const offsetRequestUrl = `${mainRequestUrl}&last-id=${offset}`;

      const requestUrl = offset ? offsetRequestUrl : mainRequestUrl;

      fetch(requestUrl, requestHeaders)
        .then(response => response.json())
        .then(result => {
          const commentsList = result.data;
          const lastCommentId = commentsList[commentsList.length - 1].id;

          if (commentsList.length !== 10)
            resolve({ commentsList, lastCommentId, btnShowMore: false });
          const newOffsetRequestUrl = `${mainRequestUrl}&last-id=${lastCommentId}`;
          fetch(newOffsetRequestUrl, requestHeaders)
            .then(response => response.json())
            .then(result =>
              result.data.length
                ? resolve({ commentsList, lastCommentId, btnShowMore: true })
                : resolve({
                    commentsList,
                    lastCommentId,
                    btnShowMore: false,
                  }),
            );
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });

  componentDidMount() {
    this.fetchComments(this.state.filmId).then(result => this.setState(result));
  }

  getCommentsOffset = filmId => {
    const { lastCommentId } = this.state;
    const previousCommentsList = this.state.commentsList;

    this.fetchComments(filmId, lastCommentId).then(
      ({ commentsList, btnShowMore }) => {
        const lastCommentsListId = commentsList[commentsList.length - 1].id;
        const fullCommentsList = [...previousCommentsList, ...commentsList];
        this.setState({
          commentsList: fullCommentsList,
          lastCommentId: lastCommentsListId,
          btnShowMore,
        });
      },
    );
  };

  createStar = rating => {
    if (typeof rating !== 'number')
      throw 'incorrect data type in FilmComment.createStar';

    const newStars = [];
    for (let index = 0; index < 5; index++) {
      newStars.push(
        <div
          key={index}
          className={
            index < rating
              ? 'star-rating__item star-rating__item--active'
              : 'star-rating__item'
          }
        >
          <svg width="18" height="17">
            <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-star-rating"></use>
            {/* <use href="/src/img/icons/icons.svg#i-star-rating"></use> */}
          </svg>
        </div>,
      );
    }

    return newStars;
  };

  render() {
    const { commentsList, btnShowMore } = this.state;
    if (commentsList.length === 0) return null;
    const userId = getCookie('USER_ID');
    return (
      <div>
        <h2 className="section-title heading heading--1">Комментарии</h2>
        <div className="film__comment-block">
          {commentsList.map(comment => (
            <div
              key={comment.id}
              className="commentary"
              data-comment-id={comment.id}
              data-comment-author={comment.user_name}
              data-comment-text={comment.body}
              data-comment-rate={comment.rate}
            >
              <div className="star-rating">{this.createStar(comment.rate)}</div>
              <p className="commentary__text">{comment.body}</p>

              <p
                className="commentary__complaint"
                style={{ display: userId ? 'inline-block' : 'none' }}
              >
                Пожаловаться
              </p>

              <div className="complaint">
                <p href="#" className="complaint__link">
                  Пожаловаться
                </p>
                <label
                  className="complaint__item complaint__spam"
                  htmlFor="complaint1"
                  data-complaint="spam"
                >
                  Спам
                  <input type="radio" name="complaint" id="complaint1" />
                </label>

                <label
                  className="complaint__item complaint__abuse"
                  htmlFor="complaint2"
                  data-complaint="abuse"
                >
                  Оскорбление
                  <input type="radio" name="complaint" id="complaint2" />
                </label>

                <label
                  className="complaint__item complaint__dirty-word"
                  htmlFor="complaint3"
                  data-complaint="dirty-word"
                >
                  Нецензурная речь
                  <input type="radio" name="complaint" id="complaint3" />
                </label>
              </div>

              <div className="commentaty__info">
                <p className="commentary__author">{comment.user_name}</p>
              </div>
            </div>
          ))}
        </div>
        <button
          className={btnShowMore ? 'btn btn--outline' : 'btn--none'}
          onClick={() => this.getCommentsOffset(this.state.filmId)}
        >
          Показать еще
        </button>
      </div>
    );
  }
}
